import { MdOutlineStar, MdOutlineStarBorder } from 'react-icons/md';
import { motion } from 'framer-motion';

const StarRatingDisplay = ({ reviews, ratingsLabel = true, homePage = false }) => {
    // Calculate the average rating
    const totalRating = reviews?.reduce((sum, review) => sum + review.starRating, 0);
    const averageRating = totalRating / reviews?.length;

    // Round the rating to the nearest half (if you want half stars)
    const roundedRating = Math.round(averageRating * 2) / 2;

    return (
        <>
            {homePage ? (
                <motion.div className="flex flex-row px-2 items-center py-2 text-sm">
                    <motion.div className="flex flex-row">
                        {[1, 2, 3, 4, 5].map((index) => (
                            <motion.div key={index} className="text-2xl text-yellow-500">
                                {roundedRating >= index ? (
                                    <MdOutlineStar size={15} />
                                ) : roundedRating >= index - 0.5 ? (
                                    <MdOutlineStar size={15} style={{ color: 'gray' }} />
                                ) : (
                                    <MdOutlineStarBorder size={15} />
                                )}
                            </motion.div>
                        ))}
                    </motion.div>
                    {ratingsLabel && (
                        <motion.div className="flex flex-row mx-2 items-center text-black font-bold">
                            ({reviews?.length} ratings)
                        </motion.div>
                    )}
                </motion.div>
            ) : (
                <motion.div className="flex flex-row px-2 items-center py-2">
                    <motion.div className="flex flex-row">
                        {[1, 2, 3, 4, 5].map((index) => (
                            <motion.div key={index} className="text-2xl text-yellow-500">
                                {roundedRating >= index ? (
                                    <MdOutlineStar />
                                ) : roundedRating >= index - 0.5 ? (
                                    <MdOutlineStar style={{ color: 'gray' }} />
                                ) : (
                                    <MdOutlineStarBorder />
                                )}
                            </motion.div>
                        ))}
                    </motion.div>
                    {ratingsLabel && (
                        <motion.div className="flex flex-row mx-2 items-center text-black font-bold">
                            ({reviews.length} ratings)
                        </motion.div>
                    )}
                </motion.div>
            )}
        </>
    );
};

export default StarRatingDisplay;
